// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ──────────────────────────────────────────────────────────
   ShortcutsOverlay — app-chrome keyboard shortcuts panel
   Tokens: src/styles/tokens.css
   ────────────────────────────────────────────────────────── */

.sh-overlay__scrim {
  position: fixed;
  inset: 0;
  background: rgba(10, 22, 51, 0.32);
  z-index: var(--z-modal, 1600);
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.sh-overlay__panel {
  position: relative;
  z-index: calc(var(--z-modal, 1600) + 1);
  margin-top: 12vh;
  width: 100%;
  max-width: 420px;
  background: var(--bg-alt);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  border-radius: 2px;
  overflow: hidden;
  font-family: var(--sans);
}

/* Header */
.sh-overlay__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
}

.sh-overlay__title {
  margin: 0;
  font-family: var(--display);
  font-size: var(--fs-title-sm);
  font-weight: 400;
  color: var(--text);
  letter-spacing: -0.005em;
}

.sh-overlay__close {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid var(--border);
  cursor: pointer;
  color: var(--text-muted);
  font-size: var(--fs-ui);
  padding: 2px 6px;
  border-radius: var(--radius-1, 2px);
  transition: color var(--dur-1, 120ms) ease;
}

.sh-overlay__close:hover {
  color: var(--text);
  background: var(--bg);
}

/* Body */
.sh-overlay__body {
  padding: 8px 0 12px;
}

/* Section */
.sh-overlay__section {
  margin-bottom: 4px;
}

.sh-overlay__section-title {
  margin: 0;
  padding: 6px 16px 4px;
  font-size: var(--fs-micro);
  font-family: var(--mono);
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-muted);
}

/* List */
.sh-overlay__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Row */
.sh-overlay__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px;
  font-size: var(--fs-ui);
  color: var(--text);
}

.sh-overlay__row-label {
  color: var(--text-secondary);
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Chord */
.sh-overlay__row-chord {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  margin-left: 16px;
}

.sh-overlay__row-chord kbd {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  border-radius: 2px;
  padding: 1px 5px;
  background: var(--bg);
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/shared/ShortcutsOverlay/ShortcutsOverlay.css"],"names":[],"mappings":"AAAA;;;+DAG+D;;AAE/D;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":["/* ──────────────────────────────────────────────────────────\n   ShortcutsOverlay — app-chrome keyboard shortcuts panel\n   Tokens: src/styles/tokens.css\n   ────────────────────────────────────────────────────────── */\n\n.sh-overlay__scrim {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 22, 51, 0.32);\n  z-index: var(--z-modal, 1600);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.sh-overlay__panel {\n  position: relative;\n  z-index: calc(var(--z-modal, 1600) + 1);\n  margin-top: 12vh;\n  width: 100%;\n  max-width: 420px;\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow);\n  border-radius: 2px;\n  overflow: hidden;\n  font-family: var(--sans);\n}\n\n/* Header */\n.sh-overlay__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border);\n}\n\n.sh-overlay__title {\n  margin: 0;\n  font-family: var(--display);\n  font-size: var(--fs-title-sm);\n  font-weight: 400;\n  color: var(--text);\n  letter-spacing: -0.005em;\n}\n\n.sh-overlay__close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: 1px solid var(--border);\n  cursor: pointer;\n  color: var(--text-muted);\n  font-size: var(--fs-ui);\n  padding: 2px 6px;\n  border-radius: var(--radius-1, 2px);\n  transition: color var(--dur-1, 120ms) ease;\n}\n\n.sh-overlay__close:hover {\n  color: var(--text);\n  background: var(--bg);\n}\n\n/* Body */\n.sh-overlay__body {\n  padding: 8px 0 12px;\n}\n\n/* Section */\n.sh-overlay__section {\n  margin-bottom: 4px;\n}\n\n.sh-overlay__section-title {\n  margin: 0;\n  padding: 6px 16px 4px;\n  font-size: var(--fs-micro);\n  font-family: var(--mono);\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n/* List */\n.sh-overlay__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/* Row */\n.sh-overlay__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 16px;\n  font-size: var(--fs-ui);\n  color: var(--text);\n}\n\n.sh-overlay__row-label {\n  color: var(--text-secondary);\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Chord */\n.sh-overlay__row-chord {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n  margin-left: 16px;\n}\n\n.sh-overlay__row-chord kbd {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  color: var(--text-secondary);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  padding: 1px 5px;\n  background: var(--bg);\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
